import {get} from "@/axios/requestUtil";

export const listFiles = (token) => {
    return new Promise((resolve, reject) => {
        get('/tianyi/api/getFolder?token=' + token).then(resp => {
            if (resp.code === 0) {
                resolve(resp)
            } else {
                reject(resp)
            }
        })
    })
}
